import { defaultApi } from "@/api";
import { FEATURE_NAMES, logError, logEvent, logInfo, logMeasurement, METRIC_TYPE } from "@/loggers";
import { CreateTemplatePayload } from "../interfaces/report";

export const useTemplateManagement = () => {
  const saveTemplate = async (templateData: CreateTemplatePayload) => {
    const apiStart = performance.now();
    try {
      const response = await defaultApi.apiUnversioned.reporting.createTemplate(templateData);
      if (response.errorIndicator || response.error) {
        const error = response.error;
        logError(FEATURE_NAMES.MVS_REPORTING, `Error saving template: ${error}`);
        throw error;
      }

      logInfo(FEATURE_NAMES.MVS_REPORTING, "Template saved successfully.");
    } catch (error) {
      logEvent(FEATURE_NAMES.MVS_REPORTING, METRIC_TYPE.API_CALL_FAILURE, {
        api: "POST /templates",
        error: error instanceof Error ? error.message : String(error)
      });
      logError(FEATURE_NAMES.MVS_REPORTING, `Error saving template: ${error}`);
      throw error;
    } finally {
      logMeasurement(FEATURE_NAMES.MVS_REPORTING, METRIC_TYPE.API_CALL_LATENCY, performance.now() - apiStart, {
        api: "POST /templates"
      });
    }
  };

  return {
    saveTemplate
  };
};
